export interface HashMap<T> {
  [key: string]: T;
}

import { isNotNullOrUndefined } from "@app/core";
import { AbstractColumn } from "../models";

export const findSettingsValueToUse = <T extends AbstractColumn, K extends keyof T>(
  fieldName: K,
  fallback: T[K],
  tableSetting: T,
  columnSetting: T): T[K] => {
  for (const v of [tableSetting, columnSetting]) {

    const value = v?.[fieldName]
    if (isNotNullOrUndefined(value)) {
      return value;
    }
  }

  return fallback;
};
